// extracted by mini-css-extract-plugin
export var standaloneTable = "_g6-0";
export var standaloneTableWithBodyFill = "_g6-1";
export var withExtraHeader = "_g6-2";